/* =====================================================================
   AUTOMIST — comportements partages
   ===================================================================== */
(function () {
  'use strict';

  /* ---- les blocs apparaissent quand ils entrent dans l'ecran ----
     Un defilement rapide peut faire passer un bloc entier entre deux
     images de l'ecran : son taux d'intersection ne change jamais, et
     sans le balayage ci-dessous il resterait transparent pour toujours. */
  function reveler() {
    if (!document.querySelector('.mo-up:not(.est-la)')) return;

    function montrer(e) { e.classList.add('est-la'); }

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(document.querySelectorAll('.mo-up'), montrer);
      return;
    }

    var obs = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting) { montrer(e.target); obs.unobserve(e.target); }
      });
    }, { threshold: .1, rootMargin: '0px 0px -6% 0px' });
    Array.prototype.forEach.call(document.querySelectorAll('.mo-up:not(.est-la)'), function (e) { obs.observe(e); });

    /* le filet de securite */
    var enAttente = false;
    function balayer() {
      enAttente = false;
      var seuil = window.innerHeight * .94;
      Array.prototype.forEach.call(document.querySelectorAll('.mo-up:not(.est-la)'), function (e) {
        if (e.getBoundingClientRect().top < seuil) { montrer(e); obs.unobserve(e); }
      });
      if (!document.querySelector('.mo-up:not(.est-la)')) {
        window.removeEventListener('scroll', aLaDemande);
        window.removeEventListener('resize', aLaDemande);
      }
    }
    function aLaDemande() {
      if (enAttente) return;
      enAttente = true;
      window.requestAnimationFrame(balayer);
    }
    window.addEventListener('scroll', aLaDemande, { passive: true });
    window.addEventListener('resize', aLaDemande);
    aLaDemande();
  }

  /* ---- la barre d'achat se montre des que le bouton n'est plus a l'ecran ---- */
  /* Avant, on attendait que toute la vitrine soit passee. Sur un telephone
     court (667 px de haut), les deux boutons tombent sous le pli alors que
     la vitrine occupe encore l'ecran : le visiteur n'avait plus aucun bouton
     d'achat visible. On surveille donc le bouton lui-meme. */
  function barre() {
    var b = document.querySelector('[data-mo-barre]');
    var repere = document.querySelector('.mo-achat__form') || document.querySelector('[data-mo]');
    if (!b || !repere || !('IntersectionObserver' in window)) return;
    var obs = new IntersectionObserver(function (e) {
      b.classList.toggle('est-la', !e[0].isIntersecting);
    }, { threshold: 0 });
    obs.observe(repere);
  }

  /* ---- le menu telephone ---- */
  function menu() {
    var b = document.querySelector('[data-mo-burger]');
    var p = document.querySelector('[data-mo-menu]');
    if (!b || !p || b.getAttribute('data-mo-pret') === '1') return;
    b.setAttribute('data-mo-pret', '1');

    function fermer() {
      p.hidden = true;
      b.setAttribute('aria-expanded', 'false');
      b.setAttribute('aria-label', 'Ouvrir le menu');
    }

    b.addEventListener('click', function () {
      if (b.getAttribute('aria-expanded') === 'true') { fermer(); return; }
      p.hidden = false;
      b.setAttribute('aria-expanded', 'true');
      b.setAttribute('aria-label', 'Fermer le menu');
    });

    /* un lien choisi referme le panneau */
    Array.prototype.forEach.call(p.querySelectorAll('a'), function (a) {
      a.addEventListener('click', fermer);
    });

    /* la touche Echap aussi */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && b.getAttribute('aria-expanded') === 'true') { fermer(); b.focus(); }
    });
  }

  function demarrer() { reveler(); barre(); menu(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else { demarrer(); }
  document.addEventListener('shopify:section:load', demarrer);
})();
